// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.konio",
    name: "Konio",
    homepage: "https://konio.io",
    image_id: "305dadb1-395e-4ca8-d4d0-d8ad0cc37000",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/konio/id6453561342",
        android: "https://play.google.com/store/apps/details?id=com.adrihoke.konio",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "konio://",
        universal: "https://konio.io",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map